import { RouterModule, Routes } from '@angular/router';

import { InspectionResolver } from '../../utils/inspection.resolver';
import { NewSectionPageComponent } from '../pages/new.component';
import { NgModule } from '@angular/core';
import { SectionDetailPageComponent } from '../pages/detail.component';
import { SectionListPageComponent } from '../pages/list.component';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { PermissionGuard } from '../../utils/permission.guard';
import { environment } from '../../../environments/environment';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver, inspection: InspectionResolver },
    children: [
      { path: '', redirectTo: appRoute + '/inspections', pathMatch: 'full' },
      { path: appRoute + '/inspections/:inspectionId/sections', component: SectionListPageComponent },
      { path: appRoute + '/inspections/:inspectionId/sections/new', component: NewSectionPageComponent },
      { path: appRoute + '/inspections/:inspectionId/sections/:sectionId', component: SectionDetailPageComponent }
    ]
  },
  {
    path: '',
    resolve: { inspection: InspectionResolver },
    children: [
      {
        path: appRoute + '/templates/:inspectionId/sections/new',
        component: NewSectionPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId',
        component: SectionDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SectionRoutingModule {}
export const routedComponents = [SectionListPageComponent, SectionDetailPageComponent];
